import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'
import { pickBy } from 'lodash'
import { IFilterParams } from 'src/context/common'

export default class Aggregator {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}aggregator/`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async getStudentDetailsById(id: number | string, appCode: string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.aggreegatStudents
    try {
      const response = await this.apiServer.get(`${endUrlName}${id}/${appCode}`)
      nProgress.done()

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching student detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getDebitorder(id: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.debitenrolment
    try {
      const response = await this.apiServer.get(`${endUrlName}/${id}`)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching student detail ========>', err?.message)
      nProgress.done()
    }
  }
  async getThroughputList(filterParams?: IFilterParams) {
    nProgress.start()
    const paramWithoutNullValue = !!filterParams ? pickBy(filterParams) : {}
    const paramsAsQuery = !!paramWithoutNullValue
      ? `?${new URLSearchParams(paramWithoutNullValue as URLSearchParams).toString()}`
      : ''

    const endUrlName = `${this.baseUrl + apiEndPoints.throughput}${paramsAsQuery}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching Throughput filter data ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
}
